import styled from 'styled-components';

const NotFoundContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${props => props.theme.colors.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ImageContainer = styled.div`
  height: auto;
  max-width: 400px;
  margin: auto;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;

export { NotFoundContainer, ImageContainer, Image };
